import { http } from 'vue'

export default {
  // load company
  loadCompany (context, params = {}) {
    let withParam = params.with ? '?with=' + params.with : ''
    return http.get('companies/' + params.id + withParam)
  },
  // create a CompanyTransaction at the API server
  postCompanyTransaction (context, params = {}) {
    return http.post('company_transactions', params.data)
  },
  // load company_client_reviews from the API server
  loadCompanyTransactions (context, params = {}) {
    const withParam = ((params.with) ? '&with=' + params.with : '')
    const pageParam = '&page=' + ((params.page) ? params.page : 1)
    const typeParam = ((params.type) ? '&type=' + params.type : '')
    const periodParam = ((params.period) ? '&period=' + params.period : '')
    const statusParam = ((params.status) ? '&status=' + params.status : '')
    return http.get('company_transactions?company_id=' + params.companyId + pageParam + typeParam + periodParam + statusParam + withParam)
  },
  destroyCompany (context, params = {}) {
    return http.delete('companies/' + params.id)
  },
  // create CompanyTransaction for Pix at the API server
  postCompanyTransactionPix (context, params = {}) {
    return http.post('company_transactions/pix', params.data)
  },
  loadLastCompanyTransationPix (context, params = {}) {
    return http.get('company_transactions/pix/?company_id=' + params.companyId)
  },
  putStatusCompanyPix (context, params = {}) {
    return http.put(`company_transactions/pix/update_status/${params.transactionId}/${params.status}`)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/companies/actions.js